import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-vor-order-popup',
    templateUrl: './vor-order-popup.component.html',
    styleUrls: ['./vor-order-popup.component.scss'],
    standalone: false
})
export class VorOrderPopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, private dialogRef: MatDialogRef<VorOrderPopupComponent>){
  }
}
